module.exports = __webpack_public_path__ + "static/media/emojis2_02.c1be0390.svg";